import { useQuery } from '@tanstack/react-query';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { fetchBidHistory, type BidDetail, type BidOperatorOperation } from '../detailApi';
import { bidKey } from './useBidAction';

const dash = (value: string | number | null | undefined, suffix = '') => (value ? `${value}${suffix}` : '-');

/** Cost / commission changes made by operators and the service (legacy «История изменений (финансовый директор)»). */
export const FinancialHistory = ({ operations }: { operations: BidDetail['financial_operation'] }) => {
  const items: BidOperatorOperation[] = [
    ...(operations?.operator_change_cost ?? []),
    ...(operations?.commission && Object.keys(operations.commission).length ? [operations.commission] : []),
    ...(operations?.service_change_cost && Object.keys(operations.service_change_cost).length
      ? [operations.service_change_cost]
      : []),
  ].sort((a, b) => (b.create_time ?? 0) - (a.create_time ?? 0));

  return (
    <div className="box">
      <div className="box-header with-border">
        <h3 className="box-title">История изменений (финансовый директор)</h3>
      </div>
      <div className="box-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Дата, время</th>
              <th>Тип операции</th>
              <th>Кем изменено</th>
              <th>Старая стоимость</th>
              <th>Новая стоимость</th>
              <th>Комиссия UREMONT</th>
              <th>Комментарий</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={`${item.create_time}-${index}`}>
                <td>{formatUnixDateTime(item.create_time) || 'No create time'}</td>
                <td>{item.type_name || 'Неизвестно'}</td>
                <td>{item.operator_id || item.operator_name || '-'}</td>
                <td>{dash(item.old_cost, ' руб.')}</td>
                <td>{dash(item.new_cost, ' руб.')}</td>
                <td>{dash(item.value, ' %')}</td>
                <td>{item.comment || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/** Who closed the bid. Rendered only when there is at least one record, like legacy. */
export const CloseHistory = ({ bidId }: { bidId: number }) => {
  const { data } = useQuery({ queryKey: bidKey(bidId, 'history'), queryFn: () => fetchBidHistory(bidId) });
  if (!data?.length) return null;

  return (
    <div className="box">
      <div className="box-header with-border">
        <h3 className="box-title">Кто закрыл заявку</h3>
      </div>
      <div className="box-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>id оператора</th>
              <th>Имя оператора</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={`${row.operator_id}-${index}`}>
                <td>{row.operator_id}</td>
                <td>{row.operator_name}</td>
                <td>{formatUnixDateTime(row.create_time) || 'No create time'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
